import { ResearchRouteConfig } from '@/modules/seo/competitorresearch/ResearchRouteConfig';

export const router = ResearchRouteConfig.factory([
  {
    path: '/raven/research/comingsoon',
    name: 'research-comingsoon',
    component: () =>
      import(/* webpackChunkName: "research-coming-soon" */ './pages/ResearchComingSoon'),
  },
]);
